import { useMemo } from "react"
import { useQuery } from "urql"

import "../graphql/customerSearch"
import { SALES_SEARCH_LIMIT, SUGGESTION_DEBOUNCE_MS } from "../constants"
import type { SalesCustomer } from "../types"

import { GetSalesCustomerListDocument } from "@/graphql/codegen/graphql"
import useDebounce from "@/utils/useDebounce"

interface UseGetSalesCustomerSuggestionsReturn {
  suggestions: SalesCustomer[]
}

export const useGetSalesCustomerSuggestions = (searchInputValue: string): UseGetSalesCustomerSuggestionsReturn => {
  const debouncedQuery = useDebounce(searchInputValue.trim(), SUGGESTION_DEBOUNCE_MS)

  const [{ data }] = useQuery({
    query: GetSalesCustomerListDocument,
    variables: {
      input: {
        searchTerm: debouncedQuery || undefined,
        limit: SALES_SEARCH_LIMIT,
        offset: 0,
      },
    },
    pause: debouncedQuery.length < 2,
  })

  const suggestions = useMemo<SalesCustomer[]>(() => {
    if (data?.location?.listBillingLocations?.__typename === "BillingLocationListSuccess") {
      return data.location.listBillingLocations.billingLocations
    }
    return []
  }, [data])

  return { suggestions }
}
